import React from 'react';

import Hero from '../components/Hero';
import { DefaultLogoReel } from '../components/LogoReel';
import SectionHero from '../components/SectionHero';
import PartnerCard from '../components/PartnerCard';
import InfiniteRefinementIndexGrid from '../components/InfiniteRefinementIndexGrid';
import Section from '../components/Section';

const EcosystemPartnersIndexTemplate = ({ pageContext: { page } }) => {
  return (
    <React.Fragment>
      <Section>
        <Hero {...page} alignment="left" />
      </Section>
      <DefaultLogoReel className="mb-16 md:mb-24" />
      <Section colour="light">
        <SectionHero
          noHr
          title="GraphCMS Ecosytem Partner Network"
          description="Find a ecosystem partner from our network to assist you in your next project"
        />

        <InfiniteRefinementIndexGrid
          indexName={process.env.GATSBY_ALGOLIA_ECOSYSTEM_PARTNERS_INDEX_NAME}
          Component={PartnerCard}
          refinements={[
            {
              label: 'Category',
              attribute: 'friendlyCategories',
            },
          ]}
        />
      </Section>
      <Section>
        <SectionHero
          title="Join our partnership program"
          description="GraphCMS enables partners to fulfill client specifications faster, and at ease"
          ctas={[{ href: '/contact', label: 'Become a GraphCMS Partner' }]}
        />
      </Section>
    </React.Fragment>
  );
};

export default EcosystemPartnersIndexTemplate;
